<div *ngIf="!validating">
    <app-not-found *ngIf="!isValidToken"></app-not-found>
    <div *ngIf="isValidToken">
        <div class="row m-0" style="height:70px">
            <div *ngIf="hasReportImage" class="col-4" style="margin:auto;">
                <img *ngIf="reportImageLoaded" alt="{{'PHOTO' | translate}}" style="height: 50px;"
                    [src]="reportImageUrl">
            </div>
            <h6 class="col-8 text-center text-uppercase" style="color:#3a5161;margin:auto;font-weight:600">
                {{'CONSENT-CAPTURE' | translate}}
            </h6>
        </div>
        <hr class="mt-1" />
        <div *ngIf="!completed" #imageSection>
            <div class="ml-3 mr-3">
                <form [formGroup]="formFulfillment" class="k-form">
                    <formly-form [form]="formFulfillment" [fields]="fields" [model]="consentModel" [options]="formlyOptions"></formly-form>
                </form>
                <app-signature-pad *ngIf="!signatureImage" [memberName]="memberName" [consentModel]="consentModel"
                    [submitButtonKey]="'SUBMIT-CONSENT'" [hiddingButtons]="hiddingSignatureButtons"
                    [bypassSignature]="bypassSignature" (submitSignature)="uploadConsent($event)">
                </app-signature-pad>
                <div *ngIf="signatureImage">
                    <img [src]="signatureImage" (load)="signatureImageLoaded()">
                    {{signedDate | date:'longDate'}}
                </div>
            </div>
        </div>
        <!--Uploading-->
        <div *ngIf="uploading" class="row mt-4">
            <div class="col my-auto text-center">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
        <br />
        <!--Completed-->
        <div *ngIf="completed" class="text-center">
            <br />
            <div *ngIf="signatureImage" class="completed-container"><i class="fas fa-check-circle fa-lg mr-2"></i>
                {{'CONSENT-PROCESS-COMPLETED' | translate }}
            </div>
            <div *ngIf="!signatureImage" class="completed-container"><i class="fas fa-check-circle fa-lg mr-2"></i>
                {{'CONSENT-PROCESS-DECLINED' | translate }}
            </div>
        </div>
    </div>
</div>